const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL ||
  (process.env.NODE_ENV === 'development'
    ? 'https://thakurcapital.com/edu/api/registration'
    : 'https://thakurcapital.com/edu/api/registration')
).replace(/\/$/, '');

export const apiUrl = (path) =>
  `${API_BASE_URL}/${String(path).replace(/^\//, '')}`;

export const courseTypeFromProgramId = (programId) => {
  const numericId = Number(programId);
  return Number.isInteger(numericId) && numericId > 0
    ? `Level ${numericId - 1}`
    : null;
};

export const publicCoursePath = (courseType) => {
  const programId = programIdFromCourseType(courseType);
  return programId ? `/course/${programId}` : `/course-type/${encodeURIComponent(courseType)}`;
};

export const registrationProgramKey = (courseType) =>
  programIdFromCourseType(courseType) || encodeURIComponent(courseType);

export const programIdFromCourseType = (courseType) => {
  const match = String(courseType || '').match(/Level\s*(\d+)/i);
  return match ? Number(match[1]) + 1 : null;
};

export default API_BASE_URL;
